/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Ref_N3Inputs */

const en_to_csv_ref_n3 = /** @type {(inputs: To_Csv_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quoted, and each inner double quote is doubled.`)
};

const ko_to_csv_ref_n3 = /** @type {(inputs: To_Csv_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인용되며, 안쪽의 각 큰따옴표가 두 개로 늘어납니다.`)
};

const ja_to_csv_ref_n3 = /** @type {(inputs: To_Csv_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用され、内側の各二重引用符が 2 つに増えます。`)
};

/**
* | output |
* | --- |
* | "Quoted, and each inner double quote is doubled." |
*
* @param {To_Csv_Ref_N3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_ref_n3 = /** @type {((inputs?: To_Csv_Ref_N3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Ref_N3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_ref_n3(inputs)
	if (locale === "ko") return ko_to_csv_ref_n3(inputs)
	return ja_to_csv_ref_n3(inputs)
});